import { Platform } from '../platforms.js';

// 读取 cookie
function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : '';
}

// 探测当前平台
// 顺序：吉意宝 -> 快宝 -> 企业微信 -> 微信小程序 webview -> 微信公众号 H5 -> 浏览器
export function detect() {
  const ua = (navigator.userAgent || '').toLowerCase();

  // 吉意宝：cookie JX_http_from === 'zhongan'
  if (getCookie('JX_http_from') === 'zhongan') {
    return Platform.JIYIBAO;
  }

  // 快宝：UA 含 kbcloud 或 kuaibao
  if (ua.indexOf('kbcloud') > -1 || ua.indexOf('kuaibao') > -1) {
    return Platform.KUAIBAO;
  }

  // 企业微信：UA 含 wxwork（含企业微信小程序 webview）
  if (ua.indexOf('wxwork') > -1) {
    return Platform.WXWORK;
  }

  // 微信小程序 webview：优先检查微信注入的环境变量（官方推荐，最可靠）
  // 部分 Android 微信版本 UA 不含 miniprogram，需 fallback 到环境变量
  if (window.__wxjs_environment === 'miniprogram' || ua.indexOf('miniprogram') > -1) {
    return Platform.WXA;
  }

  // 微信公众号 H5：UA 含 micromessenger
  if (ua.indexOf('micromessenger') > -1) {
    return Platform.WEIXIN;
  }

  // 兜底：浏览器
  return Platform.BROWSER;
}
